module.exports = __webpack_public_path__ + "img/gb-placeholder-1.57a4d00b.webp";